import { Message } from 'element-ui'

export const messageUtil = {
  show(type, msg) {
    Message({
      message: msg,
      type: type,
      dangerouslyUseHTMLString: true,
      offset:50,
      duration:type === 'error' || type === 'warning' ? 2500 : 500
    })
  },
  success(msg = '') {
    this.show('success', msg)
  },
  error(msg = '') {
    this.show('error', msg)
  },
  warning(msg = '') {
    this.show('warning', msg)
  },
  info(msg = '') {
    this.show('info', msg)
  },
  closeAll(){
    Message.closeAll()
  }
}
